module.exports = __webpack_public_path__ + "img/img4-1.fc391f8b.png";